module.exports = __webpack_public_path__ + "img/404.61e92c81.svg";